import React from "react";
import {Link} from "react-router-dom";
import {
    IconButton,
    makeStyles,
    Typography
} from "@material-ui/core";
import Table from "@material-ui/core/Table";
import TableContainer
    from "@material-ui/core/TableContainer";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import Select from "@material-ui/core/Select";
import Box from "@material-ui/core/Box";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import InputAdornment
    from "@material-ui/core/InputAdornment";
import Button from "@material-ui/core/Button";
import {Delete, Edit} from "@material-ui/icons";
import ClearIcon from "@material-ui/icons/Clear";
import {DatePicker} from "@material-ui/pickers";
import {
    usePagination,
    useRowSelect,
    useTable
} from "react-table";
import {CustomCheckbox, modal} from "../../../util";
import apiHelper from "../../../util/ApiHelper";
import {
    PaginationHandler
} from "../../../util/useManualPagination";
import {useLoading} from "../../../util/LoadingProvider";
import {toast} from "react-toastify";
import dayjs from "dayjs";
import PaginationBarForHandler from "../../common/PaginationBarForHandler";

const useStyles = makeStyles((theme) => ({
    tabpanel: {
        background: "#FFFFFF",
    },
    textInput: {
        width: "100%",
        marginBottom: "12px",

        "& input": {
            fontSize: "14px",
        },
    },
    content: {
        "& .ck-editor__editable_inline": {
            minHeight: "200px",
        },
    },
    buttonGroup: {
        marginTop: "20px",
        textAlign: "right",
        "& button": {
            color: "#306F9D",
            fontSize: "13px",
            textTransform: "inherit",
        },
    },
    box: {
        padding: 0,
        background: "#ffffff",
        paddingTop: "10px",
        paddingBottom: "10px",
        minHeight: "800px",
    },
    innerBox: {
        background: "#ffffff",
        padding: theme.spacing(3),
        marginBottom: theme.spacing(4),
    },
    button: {
        backgroundColor: "#306F9D",
        textTransform: "capitalize",
        color: "white",
        "&:hover": {
            backgroundColor: "#306F9D",
        },
    },
    pagination: {
        "& .MuiTextField-root": {
            width: "35px",
            minWidth: "auto",
        },
        "& .MuiSelect-root": {
            paddingTop: "3px",
            paddingBottom: "3px",
        },
        "& input": {
            padding: "4px 0",
            marginLeft: "10px",
            marginRight: "10px",
        },
        "& button": {
            background: "white",
            color: "#cccccc",
            border: "1px solid #CCCCCC",
            minWidth: "auto",
            width: "24px",
            height: "24px",
            margin: "4px 0",
            "&.left": {
                borderRadius: "4px 0 0 4px",
                marginLeft: "10px",
            },
            "&.right": {
                borderRadius: " 0 4px 4px 0",
            },
        },
    },
}));

const IndeterminateCheckbox = React.forwardRef(
    ({indeterminate, ...rest}, ref) => {
        const defaultRef = React.useRef();
        const resolvedRef = ref || defaultRef;

        React.useEffect(() => {
            resolvedRef.current.indeterminate = indeterminate;
        }, [resolvedRef, indeterminate]);

        return <CustomCheckbox type="checkbox"
                               ref={resolvedRef} {...rest} />;
    }
);

function SubscriptionListPage(props) {
    const {match, disabled, location} = props;
    const classes = useStyles();
    const [actionType, setActionType] = React.useState("");
    const [keyword, setKeyword] = React.useState("");
    const [selectedDate, handleDateChange] = React.useState(null);
    const [data, setData] = React.useState([]);
    // for pagination
    const [totalPages, setTotalPages] = React.useState(0);
    const [totalElements, setTotalElements] = React.useState(0);
    const [paginationHandler] = React.useState(new PaginationHandler());

    const {setLoading} = useLoading();

    const CustomLink = React.useMemo(
        () =>
            React.forwardRef((linkProps, ref) => <Link
                ref={ref} {...linkProps} />),
        []
    );

    const columns = React.useMemo(
        () => [
            {
                Header: "Email",
                accessor: "email",
                Cell: ({row}) => {
                    return (
                        <Link
                            to={{
                                pathname: `${match.url}/${row.original.id}`,
                                state: {
                                    pageIndex: paginationHandler && paginationHandler.pageIndex,
                                    pageSize: paginationHandler && paginationHandler.pageSize,
                                },
                            }}
                            style={{
                                color: "#306F9D",
                                textDecoration: "none"
                            }}
                        >
                            {row.original.email}
                        </Link>
                    );
                },
            },
            {
                Header: "Subscription Date",
                accessor: "subscriptionDate",
                Cell: ({row}) => {
                    return (
                        <span>
              {dayjs(row.original.subscriptionDate).format("DD MMM YYYY")}
            </span>
                    );
                },
                disableGlobalFilter: true,
            },
        ],
        [match.url, paginationHandler]
    );

    const {
        getTableProps,
        headerGroups,
        rows,
        prepareRow,
        setPageSize,
        gotoPage,
        previousPage,
        nextPage,
        canPreviousPage,
        canNextPage,
        selectedFlatRows,
        state: {pageIndex, pageSize},
    } = useTable(
        {
            columns,
            data,
            manualPagination: true,
            pageCount: totalPages,
            initialState: {
                pageIndex: (location.state && location.state.pageIndex) || 0,
                pageSize: (location.state && location.state.pageSize) || 10,
            },
        },
        usePagination,
        useRowSelect,
        (hooks) => {
            hooks.visibleColumns.push((columns) => [
                // Let's make a column for selection
                {
                    id: "selection",
                    // The header can use the table's getToggleAllRowsSelectedProps method
                    // to render a checkbox
                    Header: ({getToggleAllRowsSelectedProps}) => (
                        <div>
                            <IndeterminateCheckbox {...getToggleAllRowsSelectedProps()} />
                        </div>
                    ),
                    // The cell can use the individual row's getToggleRowSelectedProps method
                    // to the render a checkbox
                    Cell: ({row}) => (
                        <div>
                            <IndeterminateCheckbox {...row.getToggleRowSelectedProps()} />
                        </div>
                    ),
                },
                ...columns,
                {
                    id: "action",
                    // The header can use the table's getToggleAllRowsSelectedProps method
                    // to render a checkbox
                    Header: () => <div>Action</div>,
                    // The cell can use the individual row's getToggleRowSelectedProps method
                    // to the render a checkbox
                    Cell: ({row}) => (
                        <div
                            style={{display: "inline-flex"}}>
                            {/* <IconButton
                                className={classes.iconBtn}
                                size="small"
                                component={CustomLink}
                                to={{
                                    pathname: `${match.url}/${row.original.id}`,
                                    state: {
                                        pageIndex: paginationHandler && paginationHandler.pageIndex,
                                        pageSize: paginationHandler && paginationHandler.pageSize,
                                    },
                                }}
                            >
                                <Edit fontSize="small"/>
                            </IconButton> */}
                            {disabled || (
                                <IconButton
                                    className={classes.iconBtn}
                                    size="small"
                                    onClick={() => {
                                        deleteSubscription(row.original.id);
                                    }}
                                >
                                    <Delete
                                        fontSize="inherit"/>
                                </IconButton>
                            )}
                        </div>
                    ),
                },
            ]);
        }
    );

    const getSubscriptions = React.useCallback(async () => {
        try {
            setLoading(true);
            const result = await apiHelper.hkiff.getSubscriptions();
            console.log(result);
            paginationHandler.setPageIndex(0).setRows(result.data.content);
            const content = paginationHandler.filterRowsByAll().getRows();
            setTotalPages(paginationHandler.getTotalPages());
            setTotalElements(paginationHandler.getTotalRows());
            setData(content.filter((x) => x));
        } catch (err) {
            console.log(err);
        } finally {
            setLoading(false);
        }
    }, [paginationHandler]);

    React.useEffect(() => {
        if (paginationHandler) getSubscriptions();
    }, [getSubscriptions]);

    const triggerDateFilter = React.useCallback(() => {
        setLoading(true);
        paginationHandler
            .resetRows()
            .setQueryDate("subscriptionDate", selectedDate)
            .filterRowsByAll();
        const content = paginationHandler.getRows();
        setData(content);
        setTotalElements(paginationHandler.getTotalRows());
        setTotalPages(paginationHandler.getTotalPages());
        gotoPage(0);
        setLoading(false);
    }, [gotoPage, paginationHandler, selectedDate, setLoading]);

    const triggerSearch = React.useCallback(() => {
        setLoading(true);
        paginationHandler
            .resetRows()
            .setQueryString("email", keyword)
            .filterRowsByAll();
        const content = paginationHandler.getRows();
        setData(content);
        setTotalElements(paginationHandler.getTotalRows());
        setTotalPages(paginationHandler.getTotalPages());
        gotoPage(0);
        setLoading(false);
    }, [gotoPage, keyword, paginationHandler, setLoading]);

    const handleSelectChange = (e) => {
        setActionType(e.target.value);
    };

    const deleteSubscription = async (id) => {
        const decision = await modal.fire({
            title: "Delete Subscription",
            text: "Are you sure to delete this subscription?",
            showCancelButton: true,
            confirmButtonText: `Delete`,
        });
        if (decision.isConfirmed) {
            try {
                const result = await apiHelper.hkiff.deleteSubscriptionById(id);
                if (result.status === 200) {
                    toast.dark("Subscription deleted.");
                    await getSubscriptions();
                }
                console.log(result);
            } catch (err) {
                console.log(err);
            }
        }
    };

    const handleBulkAction = React.useCallback(async () => {
        switch (actionType) {
            case "DELETE":
                const ids = selectedFlatRows.map((o) => o.original.id);
                if (ids.length > 0) {
                    const decision = await modal.fire({
                        title: "Delete Subscription(s)",
                        text: `Are you sure to delete ${ids.length} subscription(s)?`,
                        showCancelButton: true,
                        confirmButtonText: `Delete`,
                    });
                    if (decision.isConfirmed) {
                        try {
                            const promises = ids.map((id) =>
                                apiHelper.hkiff.deleteSubscriptionById(id)
                            );
                            let result = await Promise.all(promises);
                            console.log(result);
                            if (!Array.isArray(result)) result = [result];
                            if (result.every((res) => res.data.code === 0)) {
                                toast.dark(`${ids.length} subscription(s) deleted.`);
                                await getSubscriptions();
                            }
                        } catch (err) {
                            console.log(err);
                        }
                    }
                }
                break;
            default:
                break;
        }
    }, [actionType, selectedFlatRows, getSubscriptions]);

    const getKeyword = (keyword) => {
      return keyword ? `?keyword=${keyword}` : "";
    }

    return (
        <div className={classes.content}>
            <Typography variant="h4" gutterBottom>
                Subscription
            </Typography>
            <form>
                <Grid container justify="space-between">
                    <Grid container item xs={6} md={6}>
                        <Box
                            width="100%"
                            component="span"
                            display="flex"
                            alignItems="center"
                        >
                            <Box display="flex">
                                <FormControl fullWidth
                                             margin="dense"
                                             variant="outlined">
                                    <InputLabel
                                        id="demo-simple-select-outlined-label">
                                        Bulk Actions
                                    </InputLabel>
                                    <Select
                                        labelId="demo-simple-select-outlined-label"
                                        id="demo-simple-select-outlined"
                                        value={actionType}
                                        onChange={handleSelectChange}
                                        label="Bulk Actions"
                                    >
                                        <MenuItem value="">
                                            <em>None</em>
                                        </MenuItem>
                                        <MenuItem
                                            value={"DELETE"}>Delete</MenuItem>
                                    </Select>
                                </FormControl>
                            </Box>
                            <Box display="flex">
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    onClick={handleBulkAction}
                                    disabled={disabled}
                                >
                                    Apply
                                </Button>
                            </Box>
                            <Box display="flex">
                                <DatePicker
                                    variant="inline"
                                    inputVariant="outlined"
                                    openTo="year"
                                    margin="dense"
                                    views={["year", "month"]}
                                    label="Year and Month"
                                    value={selectedDate}
                                    onChange={handleDateChange}
                                    InputProps={{
                                        endAdornment: (
                                            <InputAdornment
                                                style={selectedDate || {display: "none"}}
                                                position="end"
                                            >
                                                <ClearIcon
                                                    style={{cursor: "pointer"}}
                                                    fontSize="small"
                                                    onClick={() => {
                                                        handleDateChange(null);
                                                        paginationHandler
                                                            .resetRows()
                                                            .setQueryDate("createTime", undefined)
                                                            .filterRowsByAll();
                                                    }}
                                                />
                                            </InputAdornment>
                                        ),
                                    }}
                                />
                            </Box>
                            <Box display="flex">
                                <Button
                                    type="button"
                                    variant="outlined"
                                    color="primary"
                                    onClick={() => {
                                        triggerDateFilter(selectedDate);
                                    }}
                                >
                                    Filter
                                </Button>
                            </Box>
                        </Box>
                    </Grid>
                    <Grid container item xs={6} md={6}>
                        <Box
                            width="100%"
                            component="span"
                            display="flex"
                            justifyContent="flex-end"
                            alignItems="center"
                        >
                            {/* <Box display="flex">
                                <Button
                                    variant="contained"
                                    color="primary"
                                    type="button"
                                    component={"a"}
                                    disabled={disabled}
                                >
                                    Add New Subscriber
                                </Button>
                            </Box> */}
                            <Box display="flex">
                                <Button
                                    variant="contained"
                                    color="primary"
                                    type="button"
                                    component={"a"}
                                    download
                                    href={`${process.env.REACT_APP_API_HOSTNAME}/hkiff/admin/subscribe/export${getKeyword(keyword)}`}
                                >
                                    Export
                                </Button>
                            </Box>
                            <Box display="flex">
                                <TextField
                                    id="outlined-error"
                                    label="Search"
                                    variant="outlined"
                                    margin="dense"
                                    value={keyword}
                                    onChange={(e) => setKeyword(e.target.value)}
                                />
                            </Box>
                            <Box display="flex">
                                <Button
                                    variant="outlined"
                                    color="primary"
                                    type="button"
                                    margin="dense"
                                    onClick={triggerSearch}
                                >
                                    Search Email
                                </Button>
                            </Box>
                        </Box>
                    </Grid>
                </Grid>
                <Grid container xs={12}>
                    <TableContainer
                        component={Paper}
                        style={{
                            boxShadow: "none",
                            border: "1px solid #cccccc",
                            margin: "15px 0",
                        }}
                    >
                        <fieldset disabled={disabled}
                                  className="fieldset">
                            <Table
                                aria-label="simple table"
                                component="ul"
                                style={{margin: "0"}}
                                {...getTableProps()}
                            >
                                <colgroup>
                                    <col
                                        style={{width: "5%"}}/>
                                    <col
                                        style={{width: "70%"}}/>
                                    <col
                                        style={{width: "20%"}}/>
                                    <col
                                        style={{width: "5%"}}/>
                                </colgroup>
                                <TableHead component="div">
                                    {headerGroups.map((headerGroup) => (
                                        <TableRow {...headerGroup.getHeaderGroupProps()}>
                                            {headerGroup.headers.map((column) => (
                                                <TableCell
                                                    {...column.getHeaderProps()}
                                                    className={`${column.className ?? ""}`}
                                                    style={{
                                                        paddingTop: 6,
                                                        paddingBottom: 6,
                                                        lineHeight: "1.1em",
                                                        height: "48px",
                                                    }}
                                                >
                                                    {column.render("Header")}
                                                </TableCell>
                                            ))}
                                        </TableRow>
                                    ))}
                                </TableHead>
                                <TableBody>
                                    {rows.map((row, index) => {
                                        prepareRow(row);
                                        return (
                                            <TableRow {...row.getRowProps()}>
                                                {row.cells.map((cell) => {
                                                    return (
                                                        <TableCell
                                                            {...cell.getCellProps()}
                                                            className={`${cell.column.className ?? ""}`}
                                                            style={{
                                                                paddingTop: 6,
                                                                paddingBottom: 6,
                                                                lineHeight: "1.1em",
                                                                height: "48px",
                                                            }}
                                                        >
                                                            {cell.render("Cell")}
                                                        </TableCell>
                                                    );
                                                })}
                                            </TableRow>
                                        );
                                    })}
                                </TableBody>
                            </Table>
                        </fieldset>
                    </TableContainer>
                </Grid>
                <Grid container justify="flex-end"
                      alignItems="center">
                    <Grid container item xs={5}
                          justify="flex-end">
                        <PaginationBarForHandler
                            pageSize={pageSize}
                            setPageSize={setPageSize}
                            setData={setData}
                            setTotalPages={setTotalPages}
                            paginationHandler={paginationHandler}
                            gotoPage={gotoPage}
                            pageIndex={pageIndex}
                            canPreviousPage={canPreviousPage}
                            previousPage={previousPage}
                            nextPage={nextPage}
                            canNextPage={canNextPage}
                            elementCounts={{all: totalElements, active:0, inactive: 0}}
                            status={'all'}
                        />
                    </Grid>
                </Grid>
            </form>
        </div>
    );
}

export default SubscriptionListPage;
